import script from "./add-expenses.vue?vue&type=script&setup=true&lang=js"
export * from "./add-expenses.vue?vue&type=script&setup=true&lang=js"

import "./add-expenses.vue?vue&type=style&index=0&id=b919629e&lang=css"

const __exports__ = script;

export default __exports__